export const API_URLS = {
    API_TEST: "/api/test/",
    RENEW_REFRESH_TOKEN: "/api/auth/refresh/",
    MARKET_INSIGHTS: (compsetId) => `/api/hotels/insights/?compset_id=${compsetId}`,
    RATEPARITY: (compsetId) => `/api/analytics/rate-parity/?compset_id=${compsetId}`,
    PRICING_OPPORTUNITY: (compsetId) => `/api/analytics/pricing-opportunities/?compset_id=${compsetId}`,
    COMPETITIVE_ANALYSIS: (compsetId) => `/api/analytics/competitive/?compset_id=${compsetId}`,
    ADVANCED_ANALYSIS: (compsetId) => `/api/analytics/advanced/?compset_id=${compsetId}`,
    EXPORT_ANALYSIS: (compsetId) => `/api/download-data/?compset_id=${compsetId}`,
    DEMANDS_EVENTS: (compsetId) => `/api/hotels/demand-forecast/?compset_id=${compsetId}`,
    RATE_PARITY_OFFICIAL_SITE :(compsetId) =>  `/api/client/ota-status/?compset_id=${compsetId}`,
    ALL_AI_INSIGHTS :(compsetId) =>  `/api/all/ai-insights/?compset_id=${compsetId}`,
    COMPSETS: "/api/hotels/compset/",
    RUN_COMPSET: "/api/run/compset/",
    RUN_LOGS: "/api/runs/logs/",
    PROFILE: "/api/auth/me/",
    SCHEDULE_LOGS: "/api/show/schedule/",
    TOGGLE_SCHEDULE: "/api/toggle/schedule/",
    CREATE_SCHEDULE: "/api/create/schedule/",
    REMOVE_SCHEDULE: "/api/delete/schedule/",
    LOGIN: "/api/auth/login/",
    LOGOUT: "/api/auth/logout/",
    REGISTER: "/api/auth/register/",
    GOOGLE_OAUTH: "/api/auth/google/",
    VERIFY_OTP: "/api/auth/verify-otp/",
    RESEND_OTP: "/api/auth/resend-otp/",
    GENERATE_REPORT: "/api/generate_report/",
    PLAN_DETAILS: "/api/payments/plans/",
    BUY_FREE_PLAN: "/api/buy/free-plan/",
    RAZORPAY_SUBSCRIPTION_CREATION: "/api/create/subscription/",
    RAZORPAY_ORDER_CREATION: "/api/create/order/",
    CONFIRM_SUBSCRIPTION_PAYMENT: "/api/confirm/verify/subscription/",
    CREATE_COMPSET: "/api/create/compset/",
    UPDATE_PROFILE: "/api/update/profile/",
    PAYMENT_HISTORY: "/api/user/invoice/",
    PLAN_RULES: "/api/plans/access/",
    AI_INSIGHT: "/api/ai/insights/",
    REMOVE_COMPSET: "/api/remove/competitors/",
    EDIT_COMPSET: "/api/add/competitors/",
    FORGOT_PASSWORD : "/api/auth/forgot-password/",
    RESET_PASSWORD : "/api/auth/reset-password/"
}

export const IN_APP_ROUTES = {
    LOGIN_PAGE: "/login",
    REGISTER_PAGE: "/register",
    OTP_VERIFICATION: "/otp-verification",
    COMPSET_PAGE: "/setup/compset-setup",
    DASHBOARD: "/dashboard",
    PAYMENT: "/setup/payment",
    ADD_COMPSET: "/add-compset",
    CREATE_COMPSET: "/create-compset",
    PRIVACY_POLICY : "/policy/privacy-and-policy",
    TERMS_AND_CONDITIONS : "/policy/terms-and-conditions",
    CANCELLATION_POLICY : "/policy/cancellation-and-refund",
    FORGOT_PASSWORD_PAGE : "/auth/fogot-password",
    RESET_PASSWORD_PAGE : "/auth/reset-password"
} 